<div class="speed-dial">
  <div class="scrollable-content">
    <div class="content">
      <h1>{{ 'SYSTEM_SPEED_DIALS.TITLE' | translate }}</h1>
      <mat-divider></mat-divider>
      <span>{{ 'SYSTEM_SPEED_DIALS.HELP_TEXT' | translate }}</span>

      <div class="context-card">
        <div class="context-header">{{ 'SYSTEM_SPEED_DIALS.SELECT_CONTEXT' | translate }}</div>
        <div class="context-selects">
          <mat-form-field
            appearance="outline"
            class="select-dropdown density-minus-3"
            floatLabel="always">
            <mat-label>{{ 'SYSTEM_SPEED_DIALS.SITE' | translate }}</mat-label>
            <div class="flex">
              <mat-select
                [(ngModel)]="selectedSite"
                [placeholder]="'SYSTEM_SPEED_DIALS.ALL' | translate"
                class="device-list">
                <mat-option [value]="null">{{ 'SYSTEM_SPEED_DIALS.ALL' | translate }}</mat-option>
                @for (site of sites$ | async; track site) {
                  <mat-option [value]="site">{{ site }}</mat-option>
                }
              </mat-select>
            </div>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            class="select-dropdown density-minus-3"
            floatLabel="always">
            <mat-label>{{ 'SYSTEM_SPEED_DIALS.DEPARTMENT' | translate }}</mat-label>
            <div class="flex">
              <mat-select
                [(ngModel)]="selectedDepartment"
                [placeholder]="'SYSTEM_SPEED_DIALS.ALL' | translate"
                class="device-list">
                <mat-option [value]="null">{{ 'SYSTEM_SPEED_DIALS.ALL' | translate }}</mat-option>
                @for (department of departments$ | async; track department) {
                  <mat-option [value]="department">{{ department }}</mat-option>
                }
              </mat-select>
            </div>
          </mat-form-field>
        </div>
        <div class="context-actions">
          <button
            class="copy-from-btn"
            mat-button
            (click)="openCopyFromDialog()">
            <mat-icon>content_copy</mat-icon>
            {{ 'SYSTEM_SPEED_DIALS.COPY_FROM' | translate }}
          </button>
          @if (appConfigService.features[AppFeature.AllowManageSystemSpeedDials]) {
            <button
              mat-button
              color="primary"
              (click)="openAddDialog()">
              <mat-icon>add_box</mat-icon>
              {{ 'SYSTEM_SPEED_DIALS.ADD_SPEED_DIAL' | translate }}
            </button>
          }
        </div>
      </div>

      <div class="groups-table">
        <div class="groups-table-header">
          <span>{{ 'SYSTEM_SPEED_DIALS.COL_SITE' | translate }}</span>
          <span>{{ 'SYSTEM_SPEED_DIALS.COL_DEPARTMENT' | translate }}</span>
          <span>{{ 'SYSTEM_SPEED_DIALS.COL_COUNT' | translate }}</span>
          <span></span>
        </div>
        @for (group of speedDialGroups$ | async; track group.key) {
          <div class="groups-table-row">
            <span>{{ group.site ?? ('SYSTEM_SPEED_DIALS.ALL' | translate) }}</span>
            <span>{{ group.department ?? ('SYSTEM_SPEED_DIALS.ALL' | translate) }}</span>
            <span>{{ group.count }}</span>
            <span class="row-actions">
              @if (appConfigService.features[AppFeature.AllowManageSystemSpeedDials]) {
                <mat-icon
                  class="action-icon"
                  (click)="openManageDialog(group)"
                  >edit</mat-icon
                >
                <mat-icon
                  class="action-icon"
                  (click)="confirmDeleteGroup(group)"
                  >delete</mat-icon
                >
              }
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
